// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"244be3f9","977":"5de2da51"}[chunkId] + ".chunk.js";
};